import { SectionRegistrationAttributesQuery } from '../../../../registration_attributes/queries/section_registration_attributes_query';
import { RegisterSectionsQuery } from '../../queries/register_sections_query';
import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import { IApplicationConfiguration, ISection, ISectionTime } from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant } from '../../../sections/servants/section_info_servant';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { ScheduledSectionTileServant } from '../../servants/scheduled_section_tile_servant';
import * as _4 from 'lodash4';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { MeetingTimeServant } from '../../../../components/meeting_times/servants/meeting_time_servant';
import { CourseDetailsFacade } from '../../../course_details/facades/course_details_facade';
import { SelectedSectionActionsFacade } from '../../facades/selected_section_actions_facade';

export class ScheduledSectionTile {
  private section: ISection;
  private locationAndTimes: any;
  private sectionLocation: string;
  private sectionCampus: string;
  private sectionLocationAddresses: string[];
  private sectionCourseTime: string;
  private sectionLabel: string;
  private lastDayToDrop: string;
  private lastDayToWithdraw: string;

  private showDropDates: boolean;
  private openDetailDialog: boolean = false;
  private isInSwapMode: boolean = false;
  private hasMultipleMeetingTimes: boolean = false;

  private isWithdrawEnabled: boolean = false;
  private showRegAttr: boolean;
  private parentForm?: string;

  constructor(
    private ngScheduledSectionTileServant: ScheduledSectionTileServant,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngSectionInfoServant: SectionInfoServant,
    private ngCourseDetailsFacade: CourseDetailsFacade,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngSectionSwapServant: SectionSwapServant,
    private ngMeetingTimeServant: MeetingTimeServant,
    private ngRegisterSectionsQuery: RegisterSectionsQuery,
    private ngSectionRegistrationAttributesQuery: SectionRegistrationAttributesQuery,
    private ngSelectedSectionActionsFacade: SelectedSectionActionsFacade
  ) {}

  initialize() {
    this.locationAndTimes = this.ngSectionInfoServant.calculateSectionTimes(this.section);
    this.sectionLocation = this.ngSectionInfoServant.getSectionLocationString(this.section);

    this.sectionCampus = this.ngSectionInfoServant.getSectionCampus(this.section);

    this.sectionLocationAddresses = _4
      .chain(this.section._section_times)
      .map((time: ISectionTime) => time._location.address || '')
      .compact()
      .uniq()
      .value();

    this.sectionCourseTime = this.ngSectionInfoServant.sectionCourseTime(this.section);

    this.sectionLabel = this.ngSectionInfoServant.getSectionLabel(this.section);

    this.showDropDates = !this.ngScheduledSectionStatusServant.isStatusWithdrawn(this.section);

    this.isWithdrawEnabled = this.ngScheduledSectionTileServant.isWithdrawEnabled();

    this.lastDayToDrop = this.ngScheduledSectionTileServant.getLastDayToDrop(this.section);

    this.lastDayToWithdraw = this.ngScheduledSectionTileServant.getLastDayToWithdraw(this.section);

    this.showRegAttr = !this.isInSwapMode && !!this.section._isEligibleForRegistration;

    this.isInSwapMode = this.ngSectionSwapServant.isInSwapMode();

    // TODO: Need to get conflicting status. Right now we dont have information about conflict.
    this.hasMultipleMeetingTimes = this.ngMeetingTimeServant.hasMultipleMeetingTimes(this.section);
  }

  openDetailDialogfn() {
    if (!_4.get(this.section, '_course.nk', false)) {
      return;
    }
    this.ngCourseDetailsFacade.openCourseDetails(this.section._course.nk, this.section);
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }
}

class ScheduledSectionTileComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<',
      selectedSections: '<',
      showCourseSectionsRequired: '<?',
      parentForm: '@?'
    };
    this.controller = ScheduledSectionTile;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_tile/scheduled_section_tile.html';
  }
}
angular.module('capability-ng-scheduler').component('scheduledSectionTile', new ScheduledSectionTileComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_tile/scheduled_section_tile_component.ts